import React from 'react';
import { ShieldCheckIcon, MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
export function Footer() {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();
  const scrollToSection = (id: string) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  const scrollToTop = () => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }, 100);
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };
  return <footer className="relative py-12 px-4 sm:px-6 lg:px-8 overflow-hidden bg-black border-t border-zinc-900" data-id="element-120">
      <div className="max-w-7xl mx-auto" data-id="element-121">
        {/* CTA Section */}
        <div className="text-center mb-16 pb-12 border-b border-zinc-900" data-id="element-122">
          <a href="/application" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-black bg-white rounded-lg hover:bg-zinc-100 transition-all duration-200 shadow-lg hover:shadow-xl" data-id="element-123">
            Get Started Now
          </a>
        </div>

        <div className="grid md:grid-cols-4 gap-12 mb-12" data-id="element-124">
          {/* Column 1: Company */}
          <div data-id="element-125">
            <h3 className="text-1xl font-bold mb-6 text-white tracking-tight" data-id="element-126">
              VCA CAPITAL ADVISORS INC.
            </h3>
            <p className="text-white mb-6 text-sm leading-relaxed max-w-xs" data-id="element-127">
              Empowering businesses with flexible capital solutions.
            </p>
            <div className="flex items-center gap-2 text-sm text-zinc-500" data-id="element-128">
              <ShieldCheckIcon className="w-5 h-5 text-white" data-id="element-129" />
              <span data-id="element-130">Secure & Confidential</span>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div data-id="element-131">
            <h4 className="font-bold text-lg mb-6 text-white" data-id="element-132">Quick Links</h4>
            <ul className="space-y-3 text-zinc-400 text-sm" data-id="element-133">
              <li data-id="element-134">
                <button onClick={scrollToTop} className="hover:text-white transition-colors cursor-pointer text-left" data-id="element-135">
                  Home
                </button>
              </li>
              <li data-id="element-136">
                <button onClick={() => scrollToSection('about')} className="hover:text-white transition-colors cursor-pointer text-left" data-id="element-137">
                  About Us
                </button>
              </li>
              <li data-id="element-138">
                <button onClick={() => scrollToSection('how-it-works')} className="hover:text-white transition-colors cursor-pointer text-left" data-id="element-139">
                  How It Works
                </button>
              </li>
              <li data-id="element-140">
                <button onClick={() => scrollToSection('faq')} className="hover:text-white transition-colors cursor-pointer text-left" data-id="element-141">
                  FAQ
                </button>
              </li>
              <li data-id="element-142">
                <a href="/portal" className="hover:text-white transition-colors cursor-pointer text-left" data-id="element-143">
                  Client Portal
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Funding Types */}
          <div data-id="element-144">
            <h4 className="font-bold text-lg mb-6 text-white" data-id="element-145">
              Funding Options
            </h4>
            <ul className="space-y-3 text-zinc-400 text-sm" data-id="element-146">
              <li data-id="element-147">
                <button onClick={() => scrollToSection('services')} className="hover:text-white transition-colors cursor-pointer text-left" data-id="element-148">
                  SBA Loans
                </button>
              </li>
              <li data-id="element-149">
                <button onClick={() => scrollToSection('services')} className="hover:text-white transition-colors cursor-pointer text-left" data-id="element-150">
                  Business Lines of Credit
                </button>
              </li>
              <li data-id="element-151">
                <button onClick={() => scrollToSection('services')} className="hover:text-white transition-colors cursor-pointer text-left" data-id="element-152">
                  Equipment Financing
                </button>
              </li>
              <li data-id="element-153">
                <button onClick={() => scrollToSection('services')} className="hover:text-white transition-colors cursor-pointer text-left" data-id="element-154">
                  Working Capital
                </button>
              </li>
              <li data-id="element-155">
                <button onClick={() => scrollToSection('services')} className="hover:text-white transition-colors cursor-pointer text-left" data-id="element-156">
                  Cash Advance
                </button>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact Us */}
          <div data-id="element-157">
            <h4 className="font-bold text-lg mb-6 text-white" data-id="element-158">Contact Us</h4>
            <ul className="space-y-4 text-sm" data-id="element-159">
              <li data-id="element-160">
                <a href="mailto:info@vcacapitaladvisors.com" className="flex items-start gap-3 text-zinc-400 hover:text-white transition-colors" data-id="element-161">
                  <MailIcon className="w-4 h-4 text-white mt-0.5 shrink-0" data-id="element-162" />
                  info@vcacapitaladvisors.com
                </a>
              </li>
              <li data-id="element-163">
                <a href="tel:646-331-2752" className="flex items-start gap-3 text-zinc-400 hover:text-white transition-colors" data-id="element-164">
                  <PhoneIcon className="w-4 h-4 text-white mt-0.5 shrink-0" data-id="element-165" />
                  (646) 331-2752
                </a>
              </li>
              <li data-id="element-166">
                <div className="flex items-start gap-3 text-zinc-400" data-id="element-167">
                  <MapPinIcon className="w-4 h-4 text-white mt-0.5 shrink-0" data-id="element-168" />
                  <span data-id="element-169">
                    2248 Broadway STE 1784
                    <br data-id="element-170" />
                    New York, NY 10024
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Broker Disclosure */}
        <div className="border-t border-zinc-900 pt-8 pb-2" data-id="element-171">
          <p className="text-xs text-zinc-500 max-w-3xl mx-auto text-center leading-relaxed" data-id="element-172">
            VCA Capital Advisors Inc. is a business financing brokerage and
            advisory service. We are not a direct lender, bank, or depository
            institution. Funding offers, terms, and approvals are determined
            solely by third-party funding providers.
          </p>
        </div>

        <div className="pt-6 flex flex-col justify-center items-center text-xs text-white space-y-2" data-id="element-173">
          <p data-id="element-174">© {currentYear} VCA Capital Advisors Inc. All rights reserved.</p>
          <div className="flex space-x-8" data-id="element-175">
            <a href="/privacy" className="hover:text-zinc-300 transition-colors" data-id="element-176">
              Privacy Policy
            </a>
            <a href="/terms" className="hover:text-zinc-300 transition-colors" data-id="element-177">
              Terms of Service
            </a>
            <a href="/portal" className="hover:text-zinc-300 transition-colors" data-id="element-178">
              Client Portal
            </a>
          </div>
        </div>
      </div>
    </footer>;
}